import { render, staticRenderFns } from "./edit-user-permissions.vue?vue&type=template&id=1a8a5ee4&scoped=true"
import script from "./edit-user-permissions.vue?vue&type=script&lang=js"
export * from "./edit-user-permissions.vue?vue&type=script&lang=js"
import style0 from "./edit-user-permissions.vue?vue&type=style&index=0&id=1a8a5ee4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a5ee4",
  null
  
)

export default component.exports